export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-bold-ca005637ea260e06be10da107eae7505.woff";